import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PrintDisabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"print_disabled"}/>
}
